import { jsxs as e, jsx as C } from "react/jsx-runtime";
function l(r) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21 20H4V3C4 2.4478 3.5522 2 3 2C2.4478 2 2 2.4478 2 3V21C2 21.5522 2.4478 22 3 22H21C21.5527 22 22 21.5522 22 21C22 20.4478 21.5527 20 21 20Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M6.5 15.25C6.6919 15.25 6.8838 15.1768 7.0303 15.0303L11 11.0606L12.9697 13.0303C13.1162 13.1768 13.3076 13.25 13.5 13.25C13.6924 13.25 13.8838 13.1768 14.0303 13.0303L18 9.0606L18.9697 10.0303C19.1133 10.1739 19.3047 10.25 19.5 10.25C19.5967 10.25 19.6943 10.2314 19.7871 10.1929C20.0674 10.0767 20.25 9.8033 20.25 9.5V6.5C20.25 6.0859 19.9141 5.75 19.5 5.75H16.5C16.1963 5.75 15.9229 5.9326 15.8066 6.2129C15.6914 6.4932 15.7548 6.8159 15.9697 7.0303L16.9394 8L13.4999 11.4395L11.5302 9.4698C11.2372 9.1768 10.7626 9.1768 10.4697 9.4698L5.9697 13.9698C5.6767 14.2628 5.6767 14.7374 5.9697 15.0303C6.1162 15.1768 6.3081 15.25 6.5 15.25Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  l as default
};
